export function handleMobileVh(global = window): void {
  // Define a callback function for the event listener.
  function handleOrientationChange() {
    const vh = global.innerHeight * 0.01;
    global.document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  handleOrientationChange();

  global.addEventListener('resize', () => handleOrientationChange());
}
